import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { WindowResizeService } from '../../shared/window-resize.service';

@Component({
  selector: 'app-faq-card',
  templateUrl: './faq-card.component.html',
  styleUrls: ['./faq-card.component.scss']
})
export class FaqCardComponent implements OnInit, OnDestroy {
  @Input() title: string;
  @Input() answer: string;
  @Input() searchText: string;

  public expand: boolean;
  public hideOnDesktop: boolean;
  public resizeSubscription: Subscription = null; //  Resize subscription
  public currentSize: number;

  constructor(private windowResizeService: WindowResizeService) { }

  ngOnInit() {
    this.currentSize = this.windowResizeService.getCurrentScreenSize();
    this.currentSize >= 1024 ? this.isDesktop() : this.isMobile();
    this.expand = true;
    this.resizeSubscription = this.windowResizeService.scroll$
      .subscribe(this.handleScroll.bind(this));
  }

  ngOnDestroy(): void {
    if (this.resizeSubscription) {
      this.resizeSubscription.unsubscribe();
    }
  }

  isMobile() {
    this.hideOnDesktop = false;
    this.expand = false;
  }

  isDesktop() {
    this.hideOnDesktop = true;
    this.expand = true;
  }

  openQuestion() {
    if (!this.hideOnDesktop) {
      this.expand = !this.expand;
    }
  }

  /**
   * Adapts view
   * @param width
   */
  private handleScroll(resize: number): void {
    resize >= 1024 ? this.isDesktop() : this.isMobile();
    this.currentSize = resize;
  }
}
